// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"545": "vendors","577": "__federation_expose_useHostAuthState",}[chunkId] || chunkId) + "-" + {"122": "2c7bfc488a4c79ca","545": "dbd6dba199246427","577": "38ae27adb57ed741","80": "9261627cffa9c522",}[chunkId] + ".bundle.js"
}